import _ from "lodash";
// import {isUndefined} from "element-ui/src/utils/types";

export const exportContract = (data, fileName) => {
  // 转换二进制流
  const blob = new Blob([data]);
  // const fileName = item.name
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
};
export const downloadFileUrl = (url, name) => {
  const a = document.createElement("a");
  a.style.display = "none";
  a.download = name;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
// 多个下载---压缩包文件
// export const downloadFiles = (data, name) => { // 下载压缩包文件二进制流转换
//   console.log('name',name)
//   let blob = data.data
//   let downloadElement = document.createElement('a')
//   let href = window.URL.createObjectURL(blob) //创建下载的链接
//   let fileName = data.headers['content-disposition'] ? data.headers['content-disposition'].split(';')[1].split('=')[1] : new Date().getTime() + '.xlsx'
//   //console.log('fileName', fileName)
//   downloadElement.href = href
//   const customFileName = name + '.' + fileName.substring(fileName.lastIndexOf('.') + 1)
//   //console.log('customFileName', customFileName)
//   //如果没有传自定义文件名，就默认取上传时的文件名
//   downloadElement.download = decodeURIComponent(name === undefined ? fileName : customFileName)//解码
//   //console.log('解码',downloadElement.download)
//   document.body.appendChild(downloadElement)
//   downloadElement.click()
//   document.body.removeChild(downloadElement)
//   window.URL.revokeObjectURL(href) //释放掉blob对象
// }

export function downloadFiles(res, name) {
  console.log(res, name);
  const str = res.headers["content-disposition"].indexOf("=");
  // let filename = res.headers['content-disposition'].slice(str + 1);
  const defaultFilename = res.headers["content-disposition"].slice(str + 1); // 默认fileName
  // console.log('defaultFilename', defaultFilename)
  const customFileName =
    name +
    "." +
    defaultFilename.substring(defaultFilename.lastIndexOf(".") + 1); // 自定义fileName
  // console.log('customFileName', customFileName)
  const filename = name === undefined ? defaultFilename : customFileName; // name为空时，取默认fileName，否则取自定义fileName
  // console.log('最终filename',filename)
  const conentType = res.headers["content-type"];
  const blob = new Blob([res.data], { type: conentType });
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    // tempLink.setAttribute('download', filename);
    tempLink.setAttribute("download", decodeURIComponent(filename)); // 解码);
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

/**
 *
 * @param {*} res excel文件流
 */
export function exportExcel(res) {
  const str = res.headers["content-disposition"].indexOf("=");
  const filename = res.headers["content-disposition"].slice(str + 1);
  const blob = new Blob([res.data], {
    type: "application/vnd.ms-excel;charSet=UTF-8"
  }); // 然后创建blob对象，文件类型设置为excel的类型
  if (window.navigator && window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const blobURL = window.URL.createObjectURL(blob); // 然后创建一个可访问的URL
    const tempLink = document.createElement("a"); // 创建a标签去下载
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", decodeURIComponent(filename));
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
}

/**
 * 判断对象是否非空
 * @param val
 * @returns {boolean}
 */
export const isNotNull = function(val) {
  if (typeof val === "undefined") {
    return false;
  } else if (val == null) {
    return false;
  } else {
    return true;
  }
};

/**
 * 判断对象是否非空
 * @param ms：延时毫秒数
 * @returns 无
 */
export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 获取用户角色ID在权限树中出现的顺序号（级联组件使用）
 * @param userRoleID：用户角色ID
 *        authTree:   权限树
 * @returns 顺序号
 */
function getOrderNoInAuthTree(userRoleID, authTree) {
  let orderNo = -1;
  // 遍历产品
  for (let i = 0, productLength = authTree.length; i < productLength; ++i) {
    const product = authTree[i];
    // 遍历组织角色
    for (
      let j = 0, orgRoleLength = product.children.length;
      j < orgRoleLength;
      ++j
    ) {
      const orgRole = product.children[j];
      // 遍历用户角色
      for (
        let k = 0, userRoleLength = orgRole.children.length;
        k < userRoleLength;
        ++k
      ) {
        const userRole = orgRole.children[k];
        ++orderNo;
        if (userRole.id == userRoleID) return orderNo;
      }
    }
  }
  // 查找失败
  return -1;
}

/**
 * 对用户角色ID数组进行排序，使其顺序和权限树中用户角色ID的出现顺序保持一致（级联组件使用）
 * @param userRoleIDArray:  用户角色ID数组
 *        authTree:         权限树
 * @returns 排序后的数组
 */
export function sortUserRoleIDByAuthTree(userRoleIDArray, authTree) {
  // 生成包含顺序号的对象数组
  const orderArray = [];
  for (let i = 0, length = userRoleIDArray.length; i < length; ++i) {
    const userRoleID = userRoleIDArray[i];
    const orderNo = getOrderNoInAuthTree(userRoleID, authTree);
    if (orderNo >= 0) {
      orderArray.push({ orderNo: orderNo, userRoleID: userRoleID });
    } else {
      console.error(
        "sortUserRoleIDByAuthTree，在AuthTree中无法找到UserRoleID：",
        userRoleID
      );
    }
  }
  // 按照顺序号排序顺序数组
  orderArray.sort((a, b) => a.orderNo - b.orderNo);
  // 生成新的排序后的数组
  const newArray = [];
  for (let i = 0, length = orderArray.length; i < length; ++i) {
    newArray.push(orderArray[i].userRoleID);
  }
  return newArray;
}

/**
 * 获取ID在树中出现的顺序号（级联组件使用）
 * @param id：    ID
 *        tree:   树
 * @returns 顺序号
 */
function getOrderNoInTree(id, tree) {
  let orderNo = -1;
  let position = -1;
  // 遍历
  for (let i = 0, length = tree.length; i < length; ++i) {
    const item = tree[i];
    // 匹配当前节点
    ++position;
    if (id == item.id) orderNo = position;
    // 遍历children
    else if (item.children && item.children.length > 0) {
      ++position;
      orderNo = getOrderNoInTree(id, item.children);
      if (orderNo >= 0) orderNo += position;
      position += item.children.length - 1;
    }
    // 查找成功
    if (orderNo >= 0) return orderNo;
  }
  // 查找失败
  return -1;
}

/**
 * 对ID数组进行排序，使其顺序和树中ID的出现顺序保持一致（级联组件使用）
 * @param idArray:  ID数组
 *        tree:     树
 * @returns 排序后的数组
 */
export function sortIDByTree(idArray, tree) {
  // 生成包含顺序号的对象数组
  const orderArray = [];
  for (let i = 0, length = idArray.length; i < length; ++i) {
    const id = idArray[i];
    const orderNo = getOrderNoInTree(id, tree);
    if (orderNo >= 0) orderArray.push({ orderNo: orderNo, id: id });
    else console.error("sortIDByTree，在Tree中无法找到ID：", id);
  }
  // 按照顺序号排序顺序数组
  orderArray.sort((a, b) => a.orderNo - b.orderNo);
  // 生成新的排序后的数组
  const newArray = [];
  for (let i = 0, length = orderArray.length; i < length; ++i) {
    newArray.push(orderArray[i].id);
  }
  return newArray;
}

/**
 * 检测数据类型，返回小写的字符串
 * @param data
 */
export const types = data =>
  Object.prototype.toString
    .call(data)
    .split("[object")[1]
    .replace(/\s|\]/g, "")
    .toLowerCase();

/**
 *
 * @param {*} list
 * @param {*} options
 * @returns
 */
export const dataToTree = (list = [], options = {}) => {
  const { id = "id", parent = "parentId", children = "children" } = options;
  const tree = [];
  const record = {};
  const length = list.length;

  for (let i = 0; i < length; i++) {
    const item = list[i];

    item[children] = []; // 重置 children
    record[item[id]] = item;
  }

  for (let i = 0; i < length; i++) {
    const item = list[i];

    if (item[parent]) {
      if (record[item[parent]]) {
        record[item[parent]][children].push(item);
      }
    } else {
      tree.push(item);
    }
  }

  return tree;
};

export const filterTreeEmptyChildren = (list, options = {}) => {
  const { children = "children" } = options;
  list.forEach(item => {
    if (item[children].length) {
      filterTreeEmptyChildren(item[children], options);
    } else {
      delete item[children];
    }
  });
};

export const getDataListToTree = (options = {}, result) => {
  const { item, list, key = "name" } = options;
  // 最顶级
  if (item.parentId === 0) {
    result.push(item[key]);
  } else {
    const parentItem = list.filter(i => i.id === item.parentId);
    if (parentItem.length) {
      result.push(item[key]);
      getDataListToTree({ item: parentItem[0], list, key }, result);
    }
  }
};

/**
 * 判断是否为空参数
 * @param param
 */
export const isEmptyParam = param => param === null || param === undefined;

/**
 * 去掉前后空格
 * @param str 传递的字符串
 * @param isGlobal 去掉字符串中间的空格
 */
export const trims = (str, isGlobal = "") => {
  let result;
  result = str.replace(/(^\s+)|(\s+$)/g, "");
  if (isGlobal.toLowerCase() === "g") {
    result = result.replace(/\s/g, "");
  }
  return result;
};

/**
 * filter empty params
 * @param {*} param
 */
export const filterEmptyParams = param => {
  const newParam = _.cloneDeep(param);
  Object.keys(newParam).forEach(key => {
    if (isEmptyParam(newParam[key])) {
      delete newParam[key];
    }
  });
  return newParam;
};

export const deepClone = target => {
  // 定义一个变量
  let result;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === "object") {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (const i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]));
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (const i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
};

/**
 *
 * @param {*} formData
 *
 */
export const resetForm = formData => {
  Object.keys(formData).forEach(item => {
    if (formData[item] instanceof Array) {
      formData[item] = [];
    } else if (formData[item] instanceof Object) {
      formData[item] = null;
    } else if (
      typeof formData[item] === "string" ||
      typeof formData[item] === "number"
    ) {
      // form表单初始化
      formData[item] = "";
    }
  });
};

/**
 *
 * @param {*} email
 * 邮箱验证
 */

export function validateEmail(email) {
  const reg = /^[\u4e00-\u9fa5a-zA-Z\d]+([-_.][\u4e00-\u9fa5A-Za-z\d]+)*@([\u4e00-\u9fa5A-Za-z\d]+[-.]){1,2}[\u4e00-\u9fa5A-Za-z\d]{2,5}$/g;
  return reg.test(email);
}



// WEBPACK FOOTER //
// ./src/utils/common.js